module.exports = __webpack_public_path__ + "static/js-exp-516db3bb8a870b602d72378b46c9a4cf.svg";